module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes,
      "activeRoute": _vm.activeRoute
    }
  }), _vm._v(" "), (_vm.orderDataShow && _vm.orderDataShow.attributes.status >= 4) ? _c('div', [_c('div', {
    staticClass: "card-status-content"
  }, [_c('div', {
    staticClass: "card-status-block"
  }, [(_vm.orderDataShow.attributes.status == 5) ? _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.confirmArrivalPurchaseOrderToOrigin(_vm.id)
      }
    }
  }, [_vm._v("Confirmar correcta recepción")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.backToDetail()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-long-arrow-alt-left"
  }), _vm._v("Volver al detalle")]), _vm._v(" "), (_vm.orderDataShow.attributes.status >= 1 && _vm.orderDataShow.attributes.status <= 3) ? _c('span', {
    staticClass: "btn statusInit"
  }, [_vm._v("Inicializando")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status >= 4 && _vm.orderDataShow.attributes.status <= 7) ? _c('span', {
    staticClass: "btn statusProgress"
  }, [_vm._v("En proceso")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 8) ? _c('span', {
    staticClass: "btn statusProgress"
  }, [_vm._v("Finalizado")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10) ? _c('span', {
    staticClass: "btn statusCancel"
  }, [_vm._v("Cancelado")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 1) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("En re-evaluación inicial")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 2) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Re-evaluado esperando confirmación")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 3) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Completando información de compra")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 4) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Comprado y en camino a dirección de origen")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 5) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Recibido en dirección de origen y en evaluación")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 6) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Listo para embarque")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 7) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("En embarque")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 8) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Entregado correctamente")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled_reason_flag == 1) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por decisión propia")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled_reason_flag == 2) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por incidente en tracking")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled_reason_flag == 3) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por no autorizar reposición de items")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_c('div', {
    staticClass: "nm n-1"
  }, [_c('orderImportantInfo', {
    attrs: {
      "orderDataShow": _vm.orderDataShow,
      "fromDetail": false,
      "fromTracking": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-container"
  }, [(_vm.orderDataShow.attributes.status == 4 && _vm.orderDataShow.attributes.warning_expired_flag == 0) ? _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-content-container",
    attrs: {
      "id": "headingOne"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalNewTracking",
      modifiers: {
        "modalNewTracking": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.activate_modalNewTracking_flag
    }
  }, [_vm._v("Evaluar")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalTypeReplacement",
      modifiers: {
        "modalTypeReplacement": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.activate_modalTypeReplacement_flag
    }
  }, [_vm._v("Generar incidencia")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()], 1)]), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 5 && _vm.orderDataShow.attributes.warning_expired_flag == 0) ? _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-content-container collapsed",
    attrs: {
      "id": "headingTwo"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalNewTracking",
      modifiers: {
        "modalNewTracking": true
      }
    }],
    staticClass: "btn btn-primary btn-lg"
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalTypeReplacement",
      modifiers: {
        "modalTypeReplacement": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.activate_modalTypeReplacement_flag
    }
  }, [_vm._v("Generar incidencia")]), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()], 1)]), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 6) ? _c('div', {
    staticClass: "card card-correct"
  }, [_c('div', {
    staticClass: "card-content-container",
    attrs: {
      "id": "headinThree"
    }
  }, [_c('div', {
    staticClass: "card-content-block"
  }, [(_vm.orderDataShow.attributes.warning_expired_flag == 0) ? _c('span', [_vm._v("Listo para embarcar")]) : (_vm.orderDataShow.attributes.warning_expired_flag == 1) ? _c('span', [_vm._v("Listo para embarcar con retraso")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [(_vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseThree",
      "aria-labelledby": "headinThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 4 && _vm.orderDataShow.attributes.warning_expired_flag == 1) ? _c('div', {
    staticClass: "card card-warning"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalNewTracking",
      modifiers: {
        "modalNewTracking": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Evaluar")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalTypeReplacement",
      modifiers: {
        "modalTypeReplacement": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Generar incidencia")])], 1), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) || (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 5 && _vm.orderDataShow.attributes.warning_expired_flag == 1) ? _c('div', {
    staticClass: "card card-warning"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalNewTracking",
      modifiers: {
        "modalNewTracking": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Evaluar")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalTypeReplacement",
      modifiers: {
        "modalTypeReplacement": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Generar incidencia")])], 1), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled == 1 && (_vm.orderDataShow.attributes.cancelled_reason_flag == 1 || _vm.orderDataShow.attributes.cancelled_reason_flag == 3)) ? _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_vm._m(4), _vm._v(" "), _c('li', [(_vm.orderDataShow.attributes.cancelled_reason_flag == 1) ? _c('h1', [_vm._v("Cancelado por decision propia")]) : (_vm.orderDataShow.attributes.cancelled_reason_flag == 3) ? _c('h1', [_vm._v("Cancelado por no autorizar reposición de items")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled == 1 && _vm.orderDataShow.attributes.cancelled_reason_flag == 2 &&
    _vm.orderDataShow.attributes.has_replacement_flag == false && _vm.orderDataShow.attributes.has_active_refund_flag == false && _vm.orderDataShow.attributes.trackingIncident.attributes.type == 1) ? _c('div', {
    staticClass: "card card-cancel"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReplacement",
      modifiers: {
        "modalReplacement": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.activate_modalReplacement_flag
    }
  }, [_vm._v("Generar reemplazo")])], 1), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled == 1 && _vm.orderDataShow.attributes.cancelled_reason_flag == 2 && _vm.orderDataShow.attributes.trackingIncident.attributes.type == 2) ? _c('div', {
    staticClass: "card card-cancel"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.orderDataShow.attributes.has_active_refund_flag == true) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalRefund",
      modifiers: {
        "modalRefund": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Completar rembolso")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.has_replacement_flag == false && !_vm.orderDataShow.attributes.is_from_linio_flag && !_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.redirectToCreatePurchaseOrder
    }
  }, [_vm._v("Crear reemplazo")]) : (_vm.orderDataShow.attributes.has_replacement_flag == false && _vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.redirectToCreatePurchaseOrder
    }
  }, [_vm._v("Crear reemplazo (Es linio no deberia hacerlo)")]) : _vm._e()], 1), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headinTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled == 1 && _vm.orderDataShow.attributes.cancelled_reason_flag == 2 && _vm.orderDataShow.attributes.has_replacement_flag == 1) ? _c('div', {
    staticClass: "card card-cancel"
  }, [_c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_vm._m(7), _vm._v(" "), (_vm.orderDataShow.attributes.replacementPurchaseOrder) ? _c('li', [_c('h1', [_vm._v("\n                    Orden cancelada por reemplazo, ver\n                    "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.referenceToNewPurchaseOrder()
      }
    }
  }, [_vm._v("nueva orden aqui")])])]) : _vm._e()])])]), _vm._v(" "), ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headinTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id != null) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de cliente:")]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_id) + " ")]) : ((_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id == null) || (_vm.orderDataShow.attributes.is_from_linio_flag)) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.external_client_dni != null ? _vm.orderDataShow.attributes.external_client_dni : 'No definido') + " ")]) : (!_vm.orderDataShow.attributes.is_from_grabr_flag && !_vm.orderDataShow.attributes.is_from_linio_flag && !_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(" " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes.document_number))]) : (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id != null) ? _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": 'https://grabr.io/es/users/' + _vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id,
      "target": "_blank"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id) + "\n                      ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nombres y apellidos:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.external_client_name))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.customer_first_name + " " + _vm.orderDataShow.attributes.linioOrder.attributes.customer_last_name))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_first_name + " " + _vm.orderDataShow.attributes.meliOrder.attributes.customer_last_name))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes.name + " " + _vm.orderDataShow.attributes.client.attributes.profile.attributes.surnames))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nickname:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_nickname))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Número telefónico:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_phone))]) : (_vm.orderDataShow.attributes.is_from_grabr_flag || _vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                    " + _vm._s(_vm.orderDataShow.attributes.external_client_cellphone != null ? _vm.orderDataShow.attributes.external_client_cellphone : 'No definido') + " ")]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes.cellphone))])])])])])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseshipping",
      "aria-labelledby": "headingshipping"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de envío: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_id))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.shipping_id != null ? _vm.orderDataShow.attributes.linioOrder.attributes.shipping_id : 'No definido'))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección 1: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_address != null ? _vm.orderDataShow.attributes.meliOrder.attributes.shipping_address : 'No definido'))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.shipping_address != null ? _vm.orderDataShow.attributes.linioOrder.attributes.shipping_address : 'No definido'))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección 2: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_comment != null ? _vm.orderDataShow.attributes.meliOrder.attributes.shipping_comment : 'No definido'))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Distrito: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_neighborhood != null ? _vm.orderDataShow.attributes.meliOrder.attributes.shipping_neighborhood : 'No definido'))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.shipping_neighborhood != null ? _vm.orderDataShow.attributes.linioOrder.attributes.shipping_neighborhood : 'No definido'))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_city != null ? _vm.orderDataShow.attributes.meliOrder.attributes.shipping_city : 'No definido'))])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseorder",
      "aria-labelledby": "headingorder"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de chat en Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.is_from_grabr_flag ? _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_chat_link : ''))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Grabr:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_purchase_link !== null ? _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_purchase_link : "No definido"))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Linio:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_purchase_link !== null ? _vm.orderDataShow.attributes.linioOrder.attributes.linio_purchase_link : "No definido"))])]) : _vm._e()]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Mercado Libre:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.seller_sku !== null ? _vm.orderDataShow.attributes.meliOrder.attributes.seller_sku : "No de finido"))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Link de compra final:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.real_purchase_link !== null ? _vm.orderDataShow.attributes.real_purchase_link : 'No definido',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.real_purchase_link !== null ? _vm.orderDataShow.attributes.real_purchase_link : "No definido"))])])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.travel_number) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de viaje en Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": 'https://grabr.io/es/trips/' + _vm.orderDataShow.attributes.grabrOrder.attributes.travel_number,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.travel_number))])])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_account) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_account))])]) : (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.linio_account) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Linio:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_account))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag && _vm.orderDataShow.attributes.meliOrder.attributes.meli_account) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Mercado Libre:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.meli_account))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad de origen:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.origin != undefined ? _vm.orderDataShow.attributes.origin.attributes.name : "No definido (*)"))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad de destino:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.destination != undefined ? _vm.orderDataShow.attributes.destination.attributes.name : "No definido (*)"))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de llegada al origen:")]), _vm._v(" "), (_vm.orderDataShow.attributes.promised_origin_arrival_date != null) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.promised_origin_arrival_date)))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("No definido")])]), _vm._v(" "), (_vm.orderDataShow.attributes.real_origin_arrival_date != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha real de llegada al origen:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.real_origin_arrival_date)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Entrega prometida:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.promised_delivery_date)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.real_delivery_date != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha real de llegada al cliente:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.real_delivery_date)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.carrier_name != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Transportista:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.carrier_name))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.shopping_order_number != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Número de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shopping_order_number))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.tracking_number !== null ? _vm.orderDataShow.attributes.tracking_number : "No definido"))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsePago",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de aprobación:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.payment_date_approved) + " ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_offer_date) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Método de pago:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.payment_method) + " ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.payment_method) + " ")]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tipo de pago:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.payment_type) + " ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Monto de pago:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price) + " ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price) + " ")]) : _vm._e()])])])])]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Comentarios")])]) : _vm._e(), _vm._v(" "), (true) ? _c('div', {
    staticClass: "details-content"
  }, [(!(_vm.orderDataShow.attributes.cancelled == 1 && _vm.orderDataShow.attributes.status == 10)) ? _c('div', {
    staticClass: "details-content-comments"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentContent),
      expression: "currentContent"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "maxlength": 1000,
      "rows": "1",
      "placeholder": "Deja tu comentario..."
    },
    domProps: {
      "value": (_vm.currentContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.currentContent != '') ? _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-round",
    on: {
      "click": _vm.createComment
    }
  }, [_vm._v("Enviar")])]) : _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-round"
  }, [_vm._v("Enviar")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.comments), function(comment, index) {
    return _c('comment-component', {
      key: index,
      attrs: {
        "comment": comment,
        "orderCancelledFlag": _vm.orderDataShow.attributes.status == 10 && _vm.orderDataShow.attributes.cancelled == 1
      },
      on: {
        "in-edition": _vm.disableEditComments,
        "cancel-edition": _vm.enableEditComments,
        "display-comments": _vm.displayComments,
        "comment-deleted": _vm.displayComments
      }
    })
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "nm n-2",
    attrs: {
      "id": "fixedElement"
    }
  }, [_c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('div', {
    staticClass: "details-title-item"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', [_vm._v("Precio Grabr")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', [_vm._v("Precio linio")]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', [_vm._v("Precio Mercado Libre")]) : _c('span', [_vm._v("Precio")]), _vm._v(" "), _vm._m(13)]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price)))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ +" + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price)))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.totalPrice)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(14), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax)))])]) : (_vm.isDirect && _vm.orderDataShow.attributes.real_tax != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(15), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_tax)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(16), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_fee)))])]) : (_vm.isDirect && _vm.orderDataShow.attributes.real_shipping != null) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(17), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.real_shipping)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(18), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$" + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.debit)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [(_vm.orderDataShow.attributes.grabrOrder.attributes.debit_url != null) ? _c('a', {
    staticClass: "adeudo",
    attrs: {
      "href": _vm.orderDataShow.attributes.grabrOrder.attributes.debit_url,
      "target": "_blank"
    }
  }, [_vm._m(19)]) : _vm._e()]) : (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [(_vm.orderDataShow.attributes.linioOrder.attributes.debit_url != null) ? _c('a', {
    staticClass: "adeudo",
    attrs: {
      "href": _vm.orderDataShow.attributes.linioOrder.attributes.debit_url,
      "target": "_blank"
    }
  }, [_vm._m(20)]) : _vm._e()]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Comisión (9%)")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ -" + _vm._s(_vm._f("currency")(0.09 * _vm.totalPrice)))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Rebate Bruto")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ +" + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.rebate != null ? _vm.orderDataShow.attributes.meliOrder.attributes.rebate : 0)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Comisión Rebate (9%)")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ -" + _vm._s(_vm._f("currency")(0.09 * _vm.orderDataShow.attributes.meliOrder.attributes.rebate)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("REBATE NETO")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag || _vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.meliOrder.attributes.rebate - (0.09 * _vm.orderDataShow.attributes.meliOrder.attributes.rebate))))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('div', {
    staticClass: "details-title-item"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', [_vm._v("Total Grabr")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', [_vm._v("Total Linio")]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', [_vm._v("Total Mercado Libre")]) : _c('span', [_vm._v("Total")]), _vm._v(" "), _vm._m(21)]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.totalPrice)))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.totalMeli)))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.totalPrice)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total comisiones")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.totalCommissions)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag && _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag) ? _c('div', {
    staticClass: "details-title-block summary-block-total details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_price + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_tax + _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_fee + _vm.orderDataShow.attributes.grabrOrder.attributes.debit)))])]) : (_vm.orderDataShow.attributes.is_from_linio_flag && _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag) ? _c('div', {
    staticClass: "details-title-block summary-block-total details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price + _vm.orderDataShow.attributes.linioOrder.attributes.debit)))])]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block summary-block-total details-summary-item"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/ " + _vm._s(_vm._f("currency")(_vm.totalNeto)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payed == 1 && _vm.orderDataShow.attributes.status <= 7) ? _c('div', {
    staticClass: "details-title-container"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmPendientOrder()
      }
    }
  }, [_vm._v("Confirmar pago")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status <= 7) ? _c('div', {
    staticClass: "details-title-container"
  }, [_c('button', {
    staticClass: "btn btn-light",
    staticStyle: {
      "border-color": "red"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModalConfirmation()
      }
    }
  }, [_vm._v("Cancelar orden")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModalConfirmationDelete()
      }
    }
  }, [_vm._v("Eliminar orden")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "slider",
    attrs: {
      "id": "seguimiento"
    }
  }, _vm._l((_vm.seguimientoTrackin), function(trac) {
    return _c('div', {
      key: trac.eventId,
      staticClass: "slider_content"
    }, [(trac.status == 'DELIVERED') ? _c('img', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "src": "https://www.tracktry.com/section/tracktry/images/Artboard-6.svg"
      }
    }) : (trac.status == 'Processing at UPS Facility') ? _c('img', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "src": "https://www.tracktry.com/section/tracktry/images/Artboard-5.svg"
      }
    }) : _c('img', {
      staticStyle: {
        "width": "10%"
      },
      attrs: {
        "src": "https://www.tracktry.com/section/tracktry/images/Artboard-1.svg"
      }
    }), _vm._v("\n                  " + _vm._s(new Date(trac.datetime).toDateString()) + "\n                  "), _c('p', [_c('strong', [_vm._v(_vm._s(trac.status))]), _vm._v(", " + _vm._s(trac.location))])])
  }), 0)])])])]), _vm._v(" "), _c('b-modal', {
    ref: "validacionmodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "validacionmodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-correcto text-center",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('h1')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-edit",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "cancelOrdermodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "cancelOrdermodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideCancelValidation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-no-correcto text-center"
  }, [_c('div', {
    staticClass: "cancel-body"
  }, [_c('h1')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success btn-edit",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.hideCancelValidation
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalNewTracking",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalNewTracking"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Evaluación del tracking")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalNewTracking
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha real de llegada")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalNewTracking_flag == true
      }),
      expression: "{required: this.modalNewTracking_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.realDateArrive),
      expression: "realDateArrive"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "id": "email",
      "name": "real_arrival_date",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.realDateArrive)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.realDateArrive = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('real_arrival_date')),
      expression: "errors.has('real_arrival_date')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('real_arrival_date')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso registrado")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalNewTracking_flag == true
      }),
      expression: "{required: this.modalNewTracking_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.weightOrder),
      expression: "weightOrder"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "origin_order_weight",
      "aria-describedby": "email",
      "maxlength": 8
    },
    domProps: {
      "value": (_vm.weightOrder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weightOrder = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('origin_order_weight')),
      expression: "errors.has('origin_order_weight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('origin_order_weight')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidades de peso")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalNewTracking_flag == true
      }),
      expression: "{required: this.modalNewTracking_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.originWeightUnit),
      expression: "originWeightUnit"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "weight_units"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.originWeightUnit = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Seleccionar")]), _vm._v(" "), _vm._l((_vm.listUnits), function(units) {
    return _c('option', {
      key: units.id,
      domProps: {
        "value": units
      }
    }, [_vm._v(_vm._s(units.attributes.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('weight_units')),
      expression: "errors.has('weight_units')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('weight_units')))])]), _vm._v(" "), (!_vm.oldOrderNumber) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de tracking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalNewTracking_flag == true
      }),
      expression: "{required: this.modalNewTracking_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newOrderNumber),
      expression: "newOrderNumber"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "minlength": "5",
      "name": "tracking_number",
      "aria-describedby": "email",
      "maxlength": 30
    },
    domProps: {
      "value": (_vm.newOrderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newOrderNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tracking_number')),
      expression: "errors.has('tracking_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tracking_number')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de control")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalNewTracking_flag == true
      }),
      expression: "{required: this.modalNewTracking_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.controlNumber),
      expression: "controlNumber"
    }, {
      name: "digitsonly",
      rawName: "v-digitsonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "controlNumber",
      "name": "control_number",
      "aria-describedby": "controlNumber",
      "maxlength": 10
    },
    domProps: {
      "value": (_vm.controlNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.controlNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('control_number')),
      expression: "errors.has('control_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('control_number')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.purchaseOrderEvaluation(_vm.id)
      }
    }
  }, [_vm._v("Guardar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalTypeReplacement",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalTypeReplacement"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Selecciona el tipo de incidencia")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalTypeReplacement
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalTypeReplacement_flag == true
      }),
      expression: "{required: this.modalTypeReplacement_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.storeType),
      expression: "storeType"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "incidence_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [(_vm.orderDataShow.attributes.warning_expired_flag || !_vm.orderDataShow.attributes.warning_expired_flag) ? _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Por retraso")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Por pérdida")])]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('incidence_type')),
      expression: "errors.has('incidence_type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('incidence_type')))]), _vm._v(" "), (_vm.storeType == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlTextarea1"
    }
  }, [_vm._v("Tipo de reemplazo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.storeType == 2
      }),
      expression: "{required: storeType==2}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.replacementType),
      expression: "replacementType"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "tipo_reemplazo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.replacementType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "1"
    }
  }, [_vm._v("Misma tienda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Otra tienda")])]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tipo_reemplazo')),
      expression: "errors.has('tipo_reemplazo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tipo_reemplazo')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleFormControlTextarea1"
    }
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalTypeReplacement_flag == true
      }),
      expression: "{required: this.modalTypeReplacement_flag==true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.descriptionIncidence),
      expression: "descriptionIncidence"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "exampleFormControlTextarea1",
      "rows": "3",
      "name": "incidence_description"
    },
    domProps: {
      "value": (_vm.descriptionIncidence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descriptionIncidence = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('incidence_description')),
      expression: "errors.has('incidence_description')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('incidence_description')))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateIncidence
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalReplacement",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalReplacement"
    },
    on: {
      "shown": _vm.inicialiceModalReplacement
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de reemplazo")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalReplacement
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de compra")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag && this.modalNewTracking_flag
      }),
      expression: "{required: this.modalReplacement_flag && this.modalNewTracking_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.orderNumber),
      expression: "orderNumber"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "order_number",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.orderNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.orderNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('order_number')),
      expression: "errors.has('order_number')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('order_number')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de tracking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.trackingNumber),
      expression: "trackingNumber"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "tracking_number_replacement",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.trackingNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trackingNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tracking_number_replacement')),
      expression: "errors.has('tracking_number_replacement')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tracking_number_replacement')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link de compra")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag,
        url: true
      }),
      expression: "{required: this.modalReplacement_flag, url:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.purchaseLink),
      expression: "purchaseLink"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "name": "purchase_link_replacement",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.purchaseLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.purchaseLink = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('purchase_link_replacement')),
      expression: "errors.has('purchase_link_replacement')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('purchase_link_replacement')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de llegada al origen")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dateArriveOrigin),
      expression: "dateArriveOrigin"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "id": "email",
      "name": "arrival_date_replacement",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.dateArriveOrigin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateArriveOrigin = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_date_replacement')),
      expression: "errors.has('arrival_date_replacement')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrival_date_replacement')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Entrega prometida")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dateArriveClient),
      expression: "dateArriveClient"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "id": "email",
      "name": "arrival_date_client_replacement",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.dateArriveClient)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dateArriveClient = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('arrival_date_client_replacement')),
      expression: "errors.has('arrival_date_client_replacement')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('arrival_date_client_replacement')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio real (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newRealPrice),
      expression: "newRealPrice"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newRealPrice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newRealPrice = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_real_price')),
      expression: "errors.has('new_real_price')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('new_real_price')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto real (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newRealTax),
      expression: "newRealTax"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newRealTax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newRealTax = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_real_tax')),
      expression: "errors.has('new_real_tax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('new_real_tax')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío real (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.modalReplacement_flag
      }),
      expression: "{required: this.modalReplacement_flag}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.newRealShipping),
      expression: "newRealShipping"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.newRealShipping)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newRealShipping = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('new_real_shipping')),
      expression: "errors.has('new_real_shipping')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('new_real_shipping')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateReplacement
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalRefund",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalRefund"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Datos de reembolso")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalRefund
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login text-title",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Monto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mountNew),
      expression: "mountNew"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "id": "email",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.mountNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mountNew = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de reembolso")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refundDate),
      expression: "refundDate"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "id": "email",
      "aria-describedby": "email"
    },
    domProps: {
      "value": (_vm.refundDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.refundDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates quod ut, aperiam laboriosa")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.completeRefund()
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.endRefundByTrakingIncidentID(_vm.orderDataShow.attributes.trackingIncident.id)
      }
    }
  }, [_vm._v("Finalizar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmationV2",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmationV2"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar accion:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmationV2
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("¿Estás seguro que deseas completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.notfound()
      }
    }
  }, [_vm._v("Continuar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("Se cambiará el estado de la orden a cancelado, esta acción no es reversible.\n¿Estas seguro de completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmFormModal()
      }
    }
  }, [_vm._v("Aceptar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmation()
      }
    }
  }, [_vm._v("Cancelar")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmationDelete",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmationDelete"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmationDelete
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("Se eliminará la orden de forma física, esta acción no es reversible.\n¿Estas seguro de completar esta acción?\n")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deletePurchaseOrder(_vm.id)
      }
    }
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmationDelete()
      }
    }
  }, [_vm._v("Cancelar")])])])])], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Comprado y en camino a dirección de origen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Recibido y completando datos de recepción")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h1', [_vm._v("Oferta de compra retrasada")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Recicibido con retraso y completando datos de recepción")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Cancelado por incidente en tracking: Retraso")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header collapsed",
    attrs: {
      "id": "headinTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('ul', [_c('li', [_c('p')]), _vm._v(" "), _c('li', [_c('h1', [_vm._v("Cancelado por incidente en tracking: Pérdida")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orden-subtitulo text-title"
  }, [_c('h1', [_vm._v("Detalles de la orden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos del cliente")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingshipping",
      "data-toggle": "collapse",
      "data-target": "#collapseshipping",
      "aria-expanded": "false",
      "aria-controls": "collapseshipping"
    }
  }, [_c('span', [_vm._v("Datos de envío")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingorder",
      "data-toggle": "collapse",
      "data-target": "#collapseorder",
      "aria-expanded": "false",
      "aria-controls": "collapseorder"
    }
  }, [_c('span', [_vm._v("Datos de compra")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapsePago",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos de Pago")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Precio")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("Impuesto Grabr")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Impuesto")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("Impuesto")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Impuesto")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("Recompensa Grabr")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Recompensa Grabr")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("Costo de envío")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Costo de envío")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("Adeudo")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Adeudo")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-lg btn-block btn-adeudo"
  }, [_vm._v("Pagar con"), _c('img', {
    staticClass: "paypal-img",
    attrs: {
      "src": "/static/img/paypal.svg",
      "height": "30",
      "alt": "USA flag"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-lg btn-block btn-adeudo"
  }, [_vm._v("Pagar con"), _c('img', {
    staticClass: "paypal-img",
    attrs: {
      "src": "/static/img/paypal.svg",
      "height": "30",
      "alt": "USA flag"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown show help-q"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/info-q.svg",
      "alt": "",
      "id": "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu sendi-tool",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('div', {
    staticClass: "sendi-tool-content"
  }, [_c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-title"
  }, [_vm._v("Total")])]), _vm._v(" "), _c('span', {
    staticClass: "link-tool"
  }, [_c('span', {
    staticClass: "link-tool-subtitle"
  }, [_vm._v("This device is carrier-unlocked and should work fully with the carriers")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-block details-summary-item",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#seguimiento",
      "aria-expanded": "false",
      "aria-controls": "seguimiento"
    }
  }, [_c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Seguimiento del Paquete")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-036ba600"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/tracking-order-show-view.vue
// module id = 1843
// module chunks = 1